import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'redux/slices/modalSlice';
import { modalSelector } from 'redux/selectors';
import allModals from './components';
import ModalWrapper from './ModalWrapper';

function ModalManager() {
  // getModalStyle is not a pure function, we roll the style only on the first render
  const dispatch = useDispatch();
  let { stack } = useSelector(modalSelector);

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handlers = { handleClose };
  const renderModals = stack.map(
    ({ status, key, type, error, modalProps }, idx) => {
      const ModalComponent = allModals[type];
      if (!ModalComponent) {
        return null;
      }
      return (
        <ModalWrapper handleClose={handleClose}>
          <ModalComponent {...modalProps} {...handlers} key={key + '-' + idx} />
        </ModalWrapper>
      );
    }
  );

  return <>{renderModals}</>;
}

export default ModalManager;
